import React from 'react';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import Section from '../Section';
import ContactInfoSection from '../Section/ContactInfoSection';
import { pageTitle } from '../../helpers/PageTitle';
import UpdateProfile from '../UpdateProfile';
import { BASE_URL } from "../../helpers/api";


export default function UpdateProfilePage() {
  pageTitle('UpdateProfile');
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
      //imgUrl="/images/contact/contactus.webp"
        title="Update Profile"
        subTitle="Update your profile information below"
      />
      <div className="container cs_mt_minus_110">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <UpdateProfile />
          </div>
        </div>
      </div>
    
    </>
  );
}
